const state = {
  groupUnpackedParcelQtyData: null,
}

const getters = {
}

const mutations = {
  setGroupUnpackedParcelQtyData (state, v) {
    state.groupUnpackedParcelQtyData = v
  },
}

const actions = {
  groupUnpackedParcelQty ({ state, commit, rootState }, params) {
    return rootState.axios.get('/stats/v1frontend/jyorder-stats/group-unpacked-parcel-qty', { params }).then(res => {
      commit('setGroupUnpackedParcelQtyData', res.data.model)
      return res
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
